export default "__VITE_ASSET__BoJ$1dmk__"